module.exports = __webpack_public_path__ + "media/images/riders/small/MATHIEU_VAN_DER_POEL-ef36d6fe7854ccef767f4432dd1b1e5b.png";